import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GeneralCatalogItem } from 'data-layer-cr/dist/models';
import { sortBy } from 'lodash';

import ModelsCarItem from '../../../models/Catalogs/ModelsCarItem';
import TransitInformation from '../../../models/Catalogs/TransitInformation';
import ProvinceItem from '../../../models/Catalogs/ProvinceItem';

export type CatalogState = {
  genders: GeneralCatalogItem[];
  carTypesOfUse: GeneralCatalogItem[];
  provinces: ProvinceItem[];
  transitInfo: TransitInformation;
  brands: GeneralCatalogItem[];
  models: ModelsCarItem[];
  additionalBrokers: GeneralCatalogItem[];
};

const initialState: CatalogState = {
  genders: [
    { id: 0, code: 'M', name: 'Masculino' },
    { id: 1, code: 'F', name: 'Femenino' },
  ],
  carTypesOfUse: [
    { id: 0, code: 'PARTICULAR', name: 'Particular' },
    { id: 1, code: 'COMERCIAL', name: 'Comercial' },
  ],
  provinces: [],
  transitInfo: {
    infringement: [],
    collisions: [],
    exemptions: [],
    transitTime: [],
  },
  brands: [],
  models: [],
  additionalBrokers: [],
};

const catalogSlice = createSlice({
  name: 'catalogs',
  initialState,
  reducers: {
    updateGenders: (
      state,
      action: PayloadAction<GeneralCatalogItem[]>,
    ): void => {
      state.genders = action.payload;
    },
    updateCarTypesOfUse: (
      state,
      action: PayloadAction<GeneralCatalogItem[]>,
    ): void => {
      state.carTypesOfUse = action.payload;
    },
    updateProvinces: (state, action: PayloadAction<ProvinceItem[]>): void => {
      state.provinces = action.payload;
    },
    updateTransitInfo: (
      state,
      action: PayloadAction<TransitInformation>,
    ): void => {
      state.transitInfo = action.payload;
    },
    updateBrands: (
      state,
      action: PayloadAction<GeneralCatalogItem[]>,
    ): void => {
      state.brands = sortBy(action.payload, ['name']);
    },
    updateModels: (state, action: PayloadAction<ModelsCarItem[]>): void => {
      state.models = sortBy(action.payload, ['name']);
    },
    updateAdditionalBrokers: (
      state,
      action: PayloadAction<GeneralCatalogItem[]>,
    ): void => {
      state.additionalBrokers = action.payload;
    },
  },
});

export const {
  updateGenders,
  updateCarTypesOfUse,
  updateProvinces,
  updateTransitInfo,
  updateBrands,
  updateModels,
  updateAdditionalBrokers,
} = catalogSlice.actions;

export default catalogSlice.reducer;
